import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "./config/oktaConfig";
import { getClient } from "./utils/getClient";
import "./App.css";
import SignInPage from "./SignInPage";
import Home from "./Home";
import Collection from "./Collection";
import CampaignMonitoring from "./CampaignMonitoring";

import ProtectedRoute from "./Components/ProtectedRoute";
import TestCatalog from "./TestCatalog";

const oktaAuth = new OktaAuth(oktaConfig);

const App = () => {
  const navigate = useNavigate();
  const [client, setClient] = useState("default");
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(originalUri || "/");
  };
  useEffect(() => {
    setClient(getClient());
  }, []);
  const collections = [
    "NFZCHE",
    "NFZDEU",
    "NFZESP",
    "NFZFRA",
    "NFZGBR",
    "NFZIRL",
    "NFZITA",
    "NFZPOL",
    "NFZSWE",
    "VWARG",
    "VWAUT",
    "VWBEL",
    "VWCAN",
    "VWCHE",
    "VWDEU",
    "VWESP",
    "VWFRA",
    "VWGBR",
    "VWIRL",
    "VWITA",
    "VWJPN",
    "VWMER",
    "VWMEX",
    "VWNOR",
    "VWSWE",
    "VWTUR",
    "VWUSA",
    "VWZAF",
  ];
  return (
    <>
      <div
        className={`app-container ${
          client === "cm" ? "client-cm" : "client-vw"
        }`}
      >
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
          <Routes>
            <Route key="signin" path={`/signin`} element={<SignInPage />} />
            <Route
              key="Logincallback"
              path={`/login`}
              element={<LoginCallback />}
            />

            {collections.map((item, index) => (
              <>
                <Route
                  key={index}
                  path={`/:${item.toLowerCase()}`}
                  element={
                    <ProtectedRoute>
                      <Collection />
                    </ProtectedRoute>
                  }
                />
                <Route
                  key={index}
                  path={`/:${item.toLowerCase()}/*`}
                  element={
                    <ProtectedRoute>
                      <Collection />
                    </ProtectedRoute>
                  }
                />
              </>
            ))}
            <Route
              key="Home"
              path={`/`}
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              key="CampaignMonitoring"
              path={`/campaign-monitoring`}
              element={
                <ProtectedRoute>
                  <CampaignMonitoring />
                </ProtectedRoute>
              }
            />
            <Route
              key="TestCatalog"
              path={`/test-catalog`}
              element={
                <ProtectedRoute>
                  <TestCatalog />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/signin" />} />
          </Routes>
        </Security>
      </div>
    </>
  );
};
export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
